import { systemCode } from '../..';
import { getCurrencySymbol } from './getCurrencySymbol';
import { getPrintableAmount } from './getPrintableAmount';

export function getCurrencyValue(amount, multiplier, decimals, currency) {
	let ln = getPrintableAmount(amount, multiplier, decimals);
    currency = getCurrencySymbol(currency);
	return systemCode === 'SUREBET' ?  `${currency} ${ln} ` : `${ln} ${currency}`;
}
